<template>
  <div class="question-box">
    <div class="question-title">
      <div class="train-title">
        <span>{{index}}. </span>
        <span v-html="training_title"></span>
        <span class="single-score">({{score}}分)</span>
      </div>
      <div class="train-title" v-html="training_introduce"></div>
    </div>
    <template v-if="training_url">
      <div v-for="(tr,idx) in training_url" class="question-train-url" :key="idx">
        <div class="question-option-video" v-if="jugeMaterialType(tr.name)==='video'">
          <video controls="controls" :src="tr.url"></video>
        </div>
        <div class="question-option-img" v-else-if="jugeMaterialType(tr.name)==='img'">
          <img :src="tr.url" />
        </div>
        <div class="question-option-app" v-else-if="jugeMaterialType(tr.name)==='word'">
          <p>教学文件：</p>
          <span></span><a :href="tr.url" :download="tr.name" target="_blank">{{tr.name}}</a>
        </div>
      </div>
    </template>
    <div class="question-option-material" v-if="materials.length">
      <div class="download-menu">
        <i class="el-icon-download"></i> 参考资料
      </div>
      <div slot="tip" class="el-upload__tip" style="display: inline-block; ">（下载所需资料）</div>
      <ul>
        <li v-for="(item,i) in materials" :key="i">
          <span></span><a :href="item.url" :download="item.name" target="_blank">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <i class="divider-line"></i>
    <div class="question-option-material" v-if="training_tool.length">
      <h2>实训工具</h2>
      <ul>
        <li v-for="(item,i) in training_tool" class="train-tools-li" :key="i">
          <span></span>
          <a>
            <img v-if="item.image" :src="item.image" />（点击图标跳转模拟软件）
          </a>
          <p v-if="!item.url">{{item.name}}</p>
        </li>
      </ul>
    </div>
    <div class="show-more" v-if="isParsing">
      <span @click="showMore=!showMore" v-if="!showMore">展开更多<i class="el-icon-arrow-right"></i></span>
      <span @click="showMore=!showMore" v-if="showMore">收起<i class="el-icon-arrow-down"></i></span>
    </div>
    <div v-if="showMore">
      <div class="question-train-steps" v-if="isParsing">
        <h2>实训步骤</h2>
        <div class="train-steps-item" v-for="(item,i) in training_steps" :key="i">
          <span class="steps-num">{{i+1}}</span>
          <div class="item-content" v-html="item.content"></div>
          <img v-for="(img,idx) in item.file" :src="img.url"  :key="idx"/>
          <span class="steps-end" v-if="i===training_steps.length-1">END</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["qData", "isParsing", "index"],
  data() {
    return {
      showMore: false,//展示更多
      analysisContent: '',
      questionContent: '',
      optionsContent: '',
      training_title: '',//实训标题
      training_introduce: '',//实训简介
      training_url: '',//教学材料
      materials: [],//参考资料
      training_tool: '',//实训工具
      training_steps: [],//实训步骤
      score: '',//单题分数
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
    }
  },
  mounted() {
    this.training_title = this.qData.training_title
    this.training_introduce = this.qData.training_introduce
    this.training_url = this.qData.training_url
    this.materials = this.qData.materials
    this.training_tool = this.qData.training_tool
    this.training_steps = this.qData.training_steps
    this.score = this.qData.score
  },
  methods: {
    download: function (url) {
      let a = document.createElement('a')
      a.href = url
      a.click();
    },
    //判断教学材料类型，图片/视频/文件
    jugeMaterialType: function (name) {
      let imgArr = ['.jpg', '.jpeg', '.png', '.gif']
      let videoArr = ['.mp4']
      let type = ''
      for (let i = 0; i < imgArr.length; i++) {
        if (name.indexOf(imgArr[i]) > -1) {
          type = 'img'
        }
      }
      if (!type) {
        for (let j = 0; j < videoArr.length; j++) {
          if (name.indexOf(videoArr[j]) > -1) {
            type = 'video'
          }
        }
      }
      if (!type) {
        type = 'word'
      }
      return type
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        str += ' ' + arr[value[i]] + ' '
      }
      return str
    },

  }
}
</script>

<style scoped>
</style>